import type { ColorToken } from '@adverity/ds-tokens/colors'
import { system } from 'styled-system'

import type { CssGlobals } from '~/utils/css-unit'

import type { Config, ResponsiveValue } from '../styled-system-re-exported-types'

export type ColorProps = {
    color?: ColorToken | CssGlobals
    backgroundColor?: ColorToken | CssGlobals
    opacity?: ResponsiveValue<number>
}

/** @public used in docs */
export const colorConfig = {
    color: {
        property: 'color',
        scale: 'colors',
    },
    backgroundColor: {
        property: 'backgroundColor',
        scale: 'colors',
    },
    opacity: true,
} as const satisfies Config<keyof ColorProps>

export const color = system(colorConfig)
